import { TokenQuotaUsage } from './copilot.types';

/** Shared by AgentGatewayService (integrations host, Copilot side panel) and AskAiService (core
 * API, Ask AI Agent usage menu) — both GET the same { daily, monthly, topUsersToday } shape from
 * their respective /agent/usage endpoint, just over different hosts. */
export function parseQuotaBucket(raw: unknown): TokenQuotaUsage['daily'] | null {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const b = raw as Record<string, unknown>;
  const used = Number(b.used);
  const limit = Number(b.limit);
  const remaining = Number(b.remaining);
  const percentUsed = Number(b.percentUsed);
  if (![used, limit, remaining, percentUsed].every((n) => Number.isFinite(n))) {
    return null;
  }
  return {
    used,
    limit,
    remaining,
    percentUsed: Math.min(1, Math.max(0, percentUsed)),
    period: typeof b.period === 'string' ? b.period : '',
    resetsAt: typeof b.resetsAt === 'string' ? b.resetsAt : '',
  };
}

/** Keep well-formed per-user rows; drop invalid entries. */
export function parseTopUsersToday(raw: unknown): TokenQuotaUsage['topUsersToday'] {
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .map((row) => {
      if (!row || typeof row !== 'object') {
        return null;
      }
      const o = row as Record<string, unknown>;
      const userId = typeof o.userId === 'string' ? o.userId.trim() : '';
      const tokens = Number(o.tokens);
      if (!userId || !Number.isFinite(tokens) || tokens < 0) {
        return null;
      }
      const nameRaw =
        (typeof o.name === 'string' && o.name.trim()) ||
        (typeof o.displayName === 'string' && o.displayName.trim()) ||
        '';
      return {
        userId,
        tokens: Math.floor(tokens),
        ...(nameRaw ? { name: nameRaw } : {}),
      };
    })
    .filter((row): row is NonNullable<typeof row> => row != null);
}
